export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-1.43b729ed.png";